import { create } from "zustand";
import { useFetchUserHQLocationDashBoardSlice } from "../slices/UserHQLocationDashBoardSlices/fetchUserHQLocationDashBoardSlice";
import { useCreateUpdateUserHQLocationDashBoardSlice } from "../slices/UserHQLocationDashBoardSlices/createUpdateUserHQLocationDashBoardSlice";
import { useFetchHQLocationSlice } from "../slices/UserHQLocationDashBoardSlices/fetchHQLocationSlice";
import { useFetchBricksLocationSlice } from "../slices/UserHQLocationDashBoardSlices/fetchBricksLocationSlice";

interface UserHQLocationDashBoardInterface
    extends ReturnType<typeof useFetchUserHQLocationDashBoardSlice>,
    ReturnType<typeof useCreateUpdateUserHQLocationDashBoardSlice>,
    ReturnType<typeof useFetchHQLocationSlice>,
    ReturnType <typeof useFetchBricksLocationSlice>{}

export const UserHQLocationDashBoardStore = create<UserHQLocationDashBoardInterface>(
  (...a) => ({
        ...useFetchUserHQLocationDashBoardSlice(...a), 
      ...useCreateUpdateUserHQLocationDashBoardSlice(...a),
      ...useFetchHQLocationSlice(...a),
      ...useFetchBricksLocationSlice(...a),
  })
);